import React, { Component, PropTypes } from 'react'
import './style.scss'
import { base } from '../../../config'

export class Invoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
          job: null,
          name: 'in'
        }
    }

    componentDidMount () {
      const _this = this
      _this.ref = base.syncState(`user_details/${this.props.params.uid}/jobs/${this.props.params.job}`, {
          context: _this,
          state: 'mainJob',
          keepKeys: false,
          then (data) {
            _this.ref = base.syncState(`user_details/${_this.props.params.uid}/details`, {
                context: _this,
                state: 'details',
                keepKeys: false
            })

            _this.ref = base.syncState(`user_details/${_this.props.params.uid}/sheets/${_this.props.params.job}`, {
                context: _this,
                state: 'job',
                keepKeys: false
            })
          }
      })
    }
    //"auth !== null && auth.uid === $uid && auth.uid === 'BDTGNgArzjfdHqqbSznfIF1qKKt1'"

    // user_details read "root.child('user_details').child(auth.uid).child('is_admin').val() == true"

    render() {

        console.log(this.state)

        return (
          <div className="container">
            <InvoiceSheet
                title='Quote'
                type='quote'
                class='bg-info'
                btnClass='bg-danger'
                uid={this.props.params.uid}
                job={this.state.job}
                mainJob={this.state.mainJob}
                details={this.state.details}
                jobId={this.props.params.sheet}
             />
          </div>

        )
    }
}

export default Invoice



// WEBPACK FOOTER //
// ./src/views/pages/Invoice/index.js